module.exports = __webpack_public_path__ + "img/flower_leaf_18.dec69dfd.png";